module.exports = __webpack_public_path__ + "static/media/delete.610bc899.svg";